import type { Product } from '@/domain/Product.ts';
import ProductHeadline from '../../parts/ProductHeadline/ProductHeadline.tsx';
import SkeletonText from '@/widgets/components/controls/Skeleton/SkeletonText.tsx';
import styles from './ProductHeadlineSection.module.scss';

export type ProductImageSectionProps = {
  product: Product;
  class?: string;
};

export default function ProductHeadlineSection({
  product,
  class: className
}: ProductImageSectionProps) {
  return <ProductHeadline headline={product.headline} class={className} />;
}

ProductHeadlineSection.Skeleton = function Skeleton() {
  return (
    <div class={styles.skeleton}>
      <SkeletonText class={styles.skeletonText} />
      <SkeletonText class={styles.skeletonText} />
    </div>
  );
};
